import {formatDate, formatDateOnMonth, parseHtml} from "../../commons/commons";
import {JSX} from "wfr/commons/jsx"
import {ENavLanguages, JDownloadProductMetas, L10nLabels} from "../../commons/api";
import {alert} from "../../commons/popup";
import {docProductInfos, DownloadProductComponent, families, productInfos, urltree} from "./product";
import {Dict} from "wfr/commons/common"
import {lang} from "../../commons/language-selector";
import {ETileTitle, ProductTile} from "../product-tile";

export {DescBox}

const	labels:L10nLabels = {
	[ENavLanguages.fr]: {
		releaseDate:"Date de sortie",
		releaseNote:"Note de version",
		firstReleaseDate:"Date de première sortie",
		endSupport:"Fin du support",
		publisher:"Éditeur",
		productType:"Type de produit",
		application:"Application",
		extension:"Extension",
		server:"Serveur",
		devtool:"Outil de développement",
		status:"Statut",
		product:"Produit",
		project:"Projet",
		lab:"Expérimentation",
		extType:"Type d'extension",
		skin:"Habillage graphique",
		skinDesc:"Cette extension pose un nouvel habillage graphique sur des publication existantes",
		gen:"Générateur",
		genDesc:"Cette extension propose une nouvelle publication",
		mod:"Enrichissement du modèle",
		modDesc:"Cette extension enrichi les items du modèle documentaire",
		family:"Famille",
		contributors:"Contributeur(s)",
		license:"Licence",
		openLicense:"En savoir plus sur la licence",
		popupTitle:"Statuts : Produit, Projet, Expérimentation",
		zoomImage:"Zoomer sur cette image",
		consult:"Consulter"
	},
	[ENavLanguages.en]: {
		releaseDate:"Release date",
		releaseNote:"Release note",
		firstReleaseDate:"First release date",
		endSupport:"End of support",
		publisher:"Publisher",
		productType:"Product type",
		application:"Application",
		extension:"Extension",
		server:"Server",
		devtool:"Development tool",
		status:"Status",
		product:"Product",
		project:"Projet",
		lab:"Lab",
		extType:"Extension type",
		skin:"Skin",
		skinDesc:"This extension adds a skin to existing generator",
		gen:"Generator",
		genDesc:"This extension adds a new generator",
		mod:"Model extension",
		modDesc:"This extension enriches items of the model",
		family:"Family",
		contributors:"Contributor(s)",
		license:"License",
		openLicense:"Read more on license",
		popupTitle:"Status : Product, Project, Lab",
		zoomImage:"Zoom image",
		consult:"Consult"
	}
}

const popup:Dict<Element>={
	"fr":<div class="statusPopup">
		<p><b>Produit</b> désigne une application&#xA0;:</p>
		<ul>
			<li>dont la pertinence pour un usage communautaire est prouvée par un retour d'expérience suffisant,</li>
			<li>pour laquelle une attention particulière est apportée à ce que toute évolution ne provoque pas de régression,</li>
			<li>dont l'éditeur s'est engagé à la maintenir sur le long terme, dans l'intérêt de la communauté des usagers.</li>
		</ul>
		<p><b>Projet</b> désigne une application&#xA0;:</p>
		<ul>
			<li>ayant atteint une bonne maturité dans le contexte particulier de sa réalisation et pouvant être utilisée en production,</li>
			<li>dont l'éditeur ne s'engage ni à la maintenir sur le long terme, ni à prendre en considération les remontées d'usages.</li>
		</ul>
		<p><b>Expérimentation</b> désigne une application&#xA0;:</p>
		<ul>
			<li>résultant d'un projet de recherche / innovation ne couvrant généralement pas l'ensemble des fonctionnalités attendues,</li>
			<li>qui ne sera probablement pas maintenue dans le temps mais qui est mise à la disposition de la communauté pour tests et avis et pour en ré-exploiter les idées ou l'implémentation.</li>
		</ul>
	</div>,
	"en": <div class="statusPopup">
		<p><b>Product</b> refers to an application:</p>
		<ul>
			<li>who’s relevance for a community use is proved by sufficient experience feedback,</li>
			<li>for which particular attention is paid to insure that any evolution does not lead to regression,</li>
			<li>for whom the publisher has committed to long term maintenance in the interests of the user community.</li>
		</ul>
		<p><b>Project</b> designates an application:</p>
		<ul>
			<li>having reached a good maturity in the particular context of its realization and which can be used in production,</li>
			<li>which the publisher does not undertake either to maintain in the long term or to take rise in usage into account.</li>
		</ul>
		<p><b>Lab</b> refers to an application:</p>
		<ul>
			<li>resulting from a research / innovation project not generally covering all the expected functionalities,</li>
			<li>which will probably not be maintained in time but which is made available to the community for testing and advice and to re-use the ideas or implementation.</li>
		</ul>
	</div>
}

class DescBox extends DownloadProductComponent {
	protected previousMajor:JDownloadProductMetas = null;
	protected endSupportDate:number;
	protected labels = labels


	loadData() {
		super.loadData();
		productInfos.hist.forEach(hist=>{
			if(hist.metas.majorVersion == productInfos.metas.majorVersion && hist.metas.stage == "final") this.previousMajor = hist.metas;
		});
		if(this.previousMajor && docProductInfos.metas.supportDuration){
			const date = new Date(this.previousMajor.releaseDate)
			date.setFullYear(date.getFullYear() + docProductInfos.metas.supportDuration)
			this.endSupportDate = date.getTime()
		}
	}


	rebuild() {
		if(!super.rebuild()) return false;
		this.shadowRoot.append(<div class="desc">
			<div class="cartridge">
				<div class="abstract">{parseHtml(docProductInfos.metas.docLocInfos[lang].body)}</div>
				<ul>
					{this.previousMajor ?
						<li>
							<span class="label">{this.s("firstReleaseDate")}</span>
							<span class="value">{formatDate(this.previousMajor.releaseDate)}</span>
						</li> : null}
					<li>
						<span class="label">{this.s("releaseDate")}</span>
						<span class="value">{new Date(productInfos.metas.releaseDate).toLocaleDateString("fr-FR")}</span>
					</li>
					{productInfos.metas.releaseNote ?
						<li>
							<span class="label">{this.s("releaseNote")}</span>
							<span class="value"><a class="releaseNote" href={productInfos.metas.releaseNote} target="_blank"><span>{this.s("consult")}</span></a></span>
						</li> : null}
					{this.endSupportDate ?
						<li>
							<span class="label">{this.s("endSupport")}</span>
							<span class="value">{formatDateOnMonth(this.endSupportDate)}</span>
						</li> : null}
					<li>
						<span class="label">{this.s("publisher")}</span>
						<span class="value"><a href={docProductInfos.metas.publisher.url} target="_blank"><span>{docProductInfos.metas.publisher.name}</span></a></span>
					</li>
					{docProductInfos.metas.contributors?.length > 0 ? <li>
						<span class="label">{this.s("contributors")}</span>
						<span class="value">{docProductInfos.metas.contributors.map((org, i) => {
							return <span class="contributor"><a href={org.url} target="_blank"><span>{org.name}</span></a>{i < docProductInfos.metas.contributors.length - 1 ? ", " : ""}</span>
						})}</span>
					</li>:null}
					<li>
						<span class="label">{this.s("productType")}</span>
						<span class="value">{this.s(productInfos.metas.productType)}</span>
					</li>
					{docProductInfos.metas.status?<li>
						<span class="label">{this.s("status")}</span>
						<span class="value">{this.s(docProductInfos.metas.status)} <button class="info" onclick={this.showStatusPopup}><span>?</span></button> </span>
					</li>:null}
					{productInfos.metas.extType? <li>
						<span class="label">{this.s("extType")}</span>
						<span class="value" title={this.s(`${productInfos.metas.extType}Desc`)}>{this.s(productInfos.metas.extType)}</span>
					</li>:null}
					{productInfos.metas.family?.length > 0 ? <li>
						<span class="label">{this.s("family")}</span>
						<span class="value">{productInfos.metas.family.map((family, i)=>{
							return new ProductTile(families[family.path], urltree, {title:ETileTitle.short, addClassName:"inline", noLogo:true})})}</span>
					</li>:null}
				</ul>
			</div>
			<div class="license">
				<button class="open" onclick={this.toggleLicense} title={this.s("openLicense")}><span>{this.s("license")}</span></button>
				<div class="licenseContent" hidden>{parseHtml(docProductInfos.metas.docLocInfos[lang].license)}</div>
			</div>
		</div>);
	}

	protected showStatusPopup(event:Event) {
		const db = (this.getRootNode() as ShadowRoot).host as DescBox
		alert(db.s("popupTitle"), popup[lang]);
	}

	protected toggleLicense(event:Event) {
		const db = (this.getRootNode() as ShadowRoot).host as DescBox
		const content = this.nextElementSibling;
		if(this.classList.contains("open")) {
			this.classList.remove("open")
			this.classList.add("close")
			this.setAttribute("title", db.s("close"))
			content.removeAttribute("hidden")
		}
		else {
			this.classList.remove("close")
			this.classList.add("open")
			this.setAttribute("title", db.s("openLicense"))
			content.setAttribute("hidden", "true");
		}
	}
}
customElements.define('desc-box', DescBox)